import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { User, Mail, Calendar, LogOut } from 'lucide-react';

const Profile = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  if (!user) {
    navigate('/login');
    return null;
  }

  return (
    <div className="min-h-screen pt-8 pb-20" data-testid="profile-page">
      <div className="container mx-auto px-4 md:px-8 max-w-2xl">
        {/* Header */}
        <div className="mb-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#d4af37] mb-2">Account</p>
          <h1 className="text-4xl md:text-5xl font-serif text-stone-50">Profile</h1>
        </div>

        <div className="space-y-6">
          {/* Profile Card */}
          <div className="glass-panel p-8">
            <div className="flex items-center gap-6 mb-8">
              <div className="w-20 h-20 rounded-full bg-stone-800 flex items-center justify-center">
                <User className="w-10 h-10 text-[#d4af37]" />
              </div>
              <div>
                <h2 className="text-2xl font-serif text-stone-50">{user.name}</h2>
                <p className="text-stone-500">Wine Enthusiast</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-4 p-4 bg-stone-900/30 border border-white/5">
                <Mail className="w-5 h-5 text-stone-600" />
                <div>
                  <p className="text-xs uppercase tracking-widest text-stone-600 mb-1">Email</p>
                  <p className="text-stone-300">{user.email}</p>
                </div>
              </div>

              <div className="flex items-center gap-4 p-4 bg-stone-900/30 border border-white/5">
                <Calendar className="w-5 h-5 text-stone-600" />
                <div>
                  <p className="text-xs uppercase tracking-widest text-stone-600 mb-1">Member Since</p>
                  <p className="text-stone-300">
                    {new Date(user.created_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Actions */}
          <Button
            onClick={handleLogout}
            variant="outline"
            className="w-full border-red-800 text-red-400 hover:bg-red-900/20 rounded-none uppercase tracking-widest text-xs py-5"
            data-testid="logout-btn"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Sign Out
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
